import styled, { css } from 'styled-components';
import Colors from '../../theme/Colors';

interface MenuItemProps {
  active?: boolean;
}

interface ConatinerProps {
  showScrollbar?: boolean;
}

export const ContainerTop = styled.aside<ConatinerProps>`
  display: flex;
  overflow-y: scroll;
  height: 120px;

  @media (min-width: 490px) {
    display: none;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  ${props =>
    props.showScrollbar &&
    css`
      &::-webkit-scrollbar {
        width: unset;
        height: unset;
      }
    `}
`;

export const MenuItemTop = styled.div<MenuItemProps>`
  min-width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 50px;
    height: 50px;
    margin-bottom: 8px;
  }

  p {
    margin: 0;
    text-align: center;
  }

  ${props =>
    props.active &&
    css`
      background-color: ${Colors.secondary};

      p {
        color: ${Colors.fontColorHover};
      }
    `}
`;

export const Container = styled.aside<ConatinerProps>`
  max-width: 120px;
  width: 100%;
  height: 100%;
  background-color: ${Colors.primary};
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;

  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0;

  overflow: scroll;
  padding-bottom: 75px;

  &::-webkit-scrollbar {
    width: 0;
  }

  ${props =>
    props.showScrollbar &&
    css`
      &::-webkit-scrollbar {
        width: unset;
        height: unset;
      }
    `}

  @media (max-width: 490px) {
    display: none;
    height: 0px;
  }
`;

export const MenuItem = styled.div<MenuItemProps>`
  width: 100%;
  padding: 8px 16px;
  cursor: pointer;

  min-height: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 50px;
    height: 50px;
    margin-bottom: 8px;
  }

  p {
    color: ${Colors.fontColor};
    font-weight: bold;
    margin: 0;
    text-align: center;
    font-size: 12px;
  }

  ${props =>
    props.active &&
    css`
      background-color: ${Colors.secondary};

      p {
        color: ${Colors.fontColorHover};
      }
    `}

  &:hover {
    background-color: ${Colors.secondary};

    p {
      color: ${Colors.fontColorHover};
    }
  }
`;
